export default {
	urlApis(state){ return state.urlApis; },
	langProjects(state){ return state.langProjects; },
	accessApp(state){ return state.access; },
	get_asideStorage(state){ return state.asideStorage;},
	lateral(state) { return state.lateralShow; },
	get_refresh_list(state){ return state.refresh_list;},
	get_finished(state){ return state.events_finished;},
	get_pending(state){ return state.events_pending;},
}
